import { Component, Vue } from 'vue-property-decorator';
import template from './Support.vue';
import Button from '@/components/Button';

@Component({
	mixins: [template],
	components: {
		Button
	}
})
export default class Support extends Vue {
	// FAQ items
	FAQItems = [
		{
			title: 'Kan ik mijn pakket wijzigen?',
			description:
				'<p>Yes, dit is zeker mogelijk alleen kan je dit nog niet zelf doen. Stuur ons een e-mail, en we gaan kijken naar de mogelijkheden!</p>'
		},
		{
			title: 'Wordt mijn proefabonnement automatisch omgezet?',
			description:
				'<p>Nee, QR Link ® zet nooit je proefabonnement automatisch om naar een betaald abonnement. Wij vinden het erg belangrijk dat onze software past bij jouw wensen of bedrijf. Wanneer QR Link ® voor jou dé oplossing is kun je zelf een keuze maken uit onze pakketten of contact opnemen voor een pakket op maat: het ‘Enterprise pakket’.</p>'
		},
		{
			title: 'Wat gebeurt er met mijn QR-codes na mijn proefabonnement?',
			description:
				'<p>Als je proefabonnement voorbij is en je gebruik wilt blijven maken van ons software systeem zal je een keuze moeten maken uit één van onze betaalde pakketten. Maar we geven je wel tijd. Je kan inloggen in ons softwarepakket, maar hier zal je geen wijzigingen meer kunnen aanbrengen tot je een betaald pakket hebt afgesloten. Je QR-codes blijven wel bewaard en je kunt direct verder met het maken van dynamische QR-codes wanneer je een keuze hebt gemaakt in abonnement!</p>'
		}
	];
}
